export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：无</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<p class="text-line">1.选手解锁飞行器后，竞赛计时开始，选手启动飞行器，进入竞赛环节，并按照科目①获取物资②穿越山洞③丛林避障④钻过渠道⑤投放物资⑥精准经停⑦降落的顺序完成竞赛。</p>'+
  '<p class="text-line">2．竞赛飞行轨迹</p>'+
  '<p class="text-line">由起降平台起飞至安全高度，飞向科目①，选择合适的物资进行获取；</p>' +
  '<p class="text-line">携带物资飞往科目②，选择三个“山洞”之一，进行穿越；</p>' +
  '<p class="text-line">携带物资飞往科目③，以S形绕过“丛林”；</p>' +
  '<p class="text-line">携带物资飞往科目④，从不同高度钻过通道；</p>' + 
  '<p class="text-line">将物资投放到科目⑤指定区域；之后在科目⑥经停精准降落并停桨；</p>' +
  '<p class="text-line">之后重新起飞重复科目①-科目⑥，直至任务完成，飞往科目⑦进行精准降落。</p>' +
  '<img class="img-line" src="/work/static/img/uva/XWL/t27-new.jpg" width="100%" />' +
  '<h3 class="h3-line">飞行示意</h3>'+
  '<img class="img-line" src="/work/static/img/uva/XWL/t28.jpg" width="100%" />' +
  '</div>'
}